// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kJEK","importantInfo":"styles_importantInfo__ZfAaw"};